(function () {

    angular.module('tmx-app').factory('RequestService', ['tmxResource',
        function RequestService(tmxResource) {
            var Request = tmxResource("Request");
            

            //#region ================= Exported functions====================== 
            Request.GetAllRequests = function () {
                return Request.all();
            }

            Request.getRequestsByEntity = function(requestType,entityId) {
                return Request.getByAction('GetPendingRequests/'+requestType+'/'+entityId,false);
            }

            //#endregion

            return Request;
        }
    ]);
})();